import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import "./PriceBreakdownCell.css";

const formatMoney = (val) => {
  if (val === null || val === undefined) return "—";
  return Number(val).toFixed(2) + " EGP";
};

function PriceBreakdownCell({
  price,
  systemCut,
  voucherCode,
  discountType,
  discountValue,
  discountAmountApplied,
  doctorCut,
  finalPrice,
}) {
  const [open, setOpen] = useState(false);
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
  const cellRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const handleOutside = (e) => {
      if (cellRef.current && !cellRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    const handleKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };

    document.addEventListener("mousedown", handleOutside);
    document.addEventListener("touchstart", handleOutside);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("touchstart", handleOutside);
      document.removeEventListener("keydown", handleKey);
    };
  }, [open]);

  const handleClick = (e) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    const tooltipHeight = 190;
    const above = rect.top - tooltipHeight - 10 >= 8;
    setTooltipPos({
      x:
        Math.min(
          Math.max(rect.left + rect.width / 2 - 140, 8),
          window.innerWidth - 268,
        ),
      y: above ? rect.top - tooltipHeight - 10 : rect.bottom + 10,
    });
    setOpen((v) => !v);
  };

  return (
    <td ref={cellRef} className="price-cell" onClick={handleClick}>
      <span className="price-value">{formatMoney(price)}</span>
      <FontAwesomeIcon icon={faInfoCircle} className="price-info-icon" />

      {open && (
        <div
          className="price-tooltip"
          style={{
            left: tooltipPos.x,
            top: tooltipPos.y,
          }}
        >
          <div className="tooltip-title">Price Breakdown</div>
          <div className="tooltip-row">
            <span>Session Price</span>
            <span>{formatMoney(price)}</span>
          </div>
          <div className="tooltip-row">
            <span>System Fee</span>
            <span className="tooltip-deduction">
              -{formatMoney(systemCut)}
            </span>
          </div>
          <div className="tooltip-row">
            <span>
              {voucherCode}(
              {discountType === "percentage" ? `${discountValue}%` : "Fixed"}
              )
            </span>
            <span className="tooltip-deduction">
              -{formatMoney(discountAmountApplied)}
            </span>
          </div>
          <div className="tooltip-divider" />
          <div className="tooltip-row tooltip-total">
            <span>Doctor Receives</span>
            <span>{formatMoney(doctorCut)}</span>
          </div>
          <div className="tooltip-row tooltip-deduction">
            <span>Net</span>
            <span>{formatMoney(doctorCut - finalPrice)}</span>
          </div>
        </div>
      )}
    </td>
  );
}

export default PriceBreakdownCell;
